import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { Button, Flex, Text, useModal, Link } from '@pancakeswap-libs/uikit'
import getLiquidityUrlPathParts from 'utils/getLiquidityUrlPathParts'
import addresses from 'config/constants/contracts'
import { useTransferOwnership, useRenounce, useBurn, useAddToLiquidityGeneratorWhitelist, useRemoveFromLiquidityGeneratorWhitelist } from '../hooks/useSep20Factory'
import BurnMoal from './BurnMoal'
import TransferOwnershipModal from './TransferOwnershipModal'
import LQAddToWhiteListModal from './LQAddToWhiteListModal'
import LQRemoveFromWhiteListModal from './LQRemoveFromWhiteListModal'
import LQCheckWhiteListModal from './LQCheckWhiteListModal'

const Action = styled.div`
    padding-top: 5px;
`

interface CardActionsProps {
    token: any,
    account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ token, account }) => {
    const TranslateString = useI18n();
    const { address, owner, isMintable, decimals } = token;
    const isOwner = account && owner && owner.toLowerCase() === account.toLowerCase();

    // Transfer Ownership
    const onTransferOwnershipSubmit = useTransferOwnership(address);
    const onTransferOwnershipModalConfirm = async (newOwner) => {
        return onTransferOwnershipSubmit(newOwner);
    };
    const [onTransferOwnershipStart] = useModal(<TransferOwnershipModal onConfirm={onTransferOwnershipModalConfirm} />)

    // Add to Whitelist
    const onAddToLiquidityGeneratorWhitelistSubmit = useAddToLiquidityGeneratorWhitelist(address);
    const onAddToLiquidityGeneratorWhitelistModalConfirm = async (newOwner) => {
        return onAddToLiquidityGeneratorWhitelistSubmit(newOwner);
    };
    const [onAddToLiquidityGeneratorWhitelistStart] = useModal(<LQAddToWhiteListModal onConfirm={onAddToLiquidityGeneratorWhitelistModalConfirm} />)

    // Remove from Whitelist
    const onRemoveFromLiquidityGeneratorWhitelistSubmit = useRemoveFromLiquidityGeneratorWhitelist(address);
    const onRemoveFromLiquidityGeneratorWhitelistModalConfirm = async (newOwner) => {
        return onRemoveFromLiquidityGeneratorWhitelistSubmit(newOwner);
    };
    const [onRemoveFromLiquidityGeneratorWhitelistStart] = useModal(<LQRemoveFromWhiteListModal tokenAddress={address} onConfirm={onRemoveFromLiquidityGeneratorWhitelistModalConfirm} />)

    // Check Whitelist
    const [onCheckWhitelistStart] = useModal(<LQCheckWhiteListModal tokenAddress={address} />)

    // Renounce
    const [requestedRenounce, setRequestedRenounce] = useState(false)
    const onRenounce = useRenounce(address);
    const handleRenounce = useCallback(async () => {
        try {
            setRequestedRenounce(true)
            await onRenounce()
            setRequestedRenounce(false)
        } catch (e) {
            console.error(e)
        }
    }, [onRenounce])

    // Burn
    const tokenBalance = token.userBalance? token.userBalance.toFixed() : '0';
    const onBurnSubmit = useBurn(token)
    const onBurnModalConfirm = async (amount) => {
        return onBurnSubmit(new BigNumber(amount));
    };
    const [onBurnStart] = useModal(<BurnMoal max={tokenBalance} token={token} onConfirm={onBurnModalConfirm} />)

    // Add Liquidity
    const liquidityUrlPathParts = getLiquidityUrlPathParts({ quoteTokenAdresses:addresses.wbch, quoteTokenSymbol:'BCH', tokenAddresses: {10000:address} })

    return (
        <Action>
            <Button fullWidth onClick={onBurnStart}>
                {TranslateString(546,'Burn')}
            </Button>
            <Button mt="8px" fullWidth as="a" href={`https://dexfull.benswap.cash/#/add/${liquidityUrlPathParts}`} target="_blank">
            {TranslateString(25,"Add Liquidity")}
            </Button>
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onAddToLiquidityGeneratorWhitelistStart}>
                        {TranslateString(1059,'Add Address to Whitelist')}
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onRemoveFromLiquidityGeneratorWhitelistStart}>
                        {TranslateString(1060,'Remove Address from Whitelist')}
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onCheckWhitelistStart}>
                        {TranslateString(1061,'Check Whitelist')}
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onTransferOwnershipStart}>
                        {TranslateString(400,'Transfer Ownership')} 
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={handleRenounce} disabled={requestedRenounce}>
                    {TranslateString(1062,'Renounce Ownership')}
                    </Button>
                )
            }
        </Action>
    );
}

export default CardActions
